import React, { Component } from 'react';
import { InputLabel } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import context from './api/context';
import SubscriptionManager from './SubscriptionManager';
import { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import * as r from "ramda";
import { emptyMap } from './api/util';

const styles = () => ({
  pairControl: {
    minWidth: 240
  },
  dateControl: {
    minWidth: 180
  }
});

class PairDatePicker extends Component {

  state = {
    pairs: [],
    dates: [],
    pair: "",
    date: ""
  }

  subs = new SubscriptionManager();

  componentWillMount() {
    this.subs.subscribe(context.pairs, pairs => {
      this.setState({ pairs }, () => {
        if (!pairs.pairs.includes(this.state.pair)) {
          this.setSelectionField('pair', emptyMap(r.prop('name'), pairs.pairs[0]));
        }
      })
    });
    this.subs.subscribe(context.dates, dates => this.setState({ dates }, () => {
      if (!dates.dates.includes(this.state.date)) {
        this.setSelectionField('date', emptyMap((date) => date.valueOf(), dates.next));
      }
    }))
  }

  componentWillUnmount() {
    this.subs.unsubscribe();
  }

  setSelectionField(field, value) {
    this.setState({
      [field]: value
    }, () => {
      if (this.props.onChange) {
        this.props.onChange({
          pair: emptyMap(r.find(pair => pair.name === this.state.pair), this.state.pairs.pairs),
          date: emptyMap(r.find(date => date.valueOf() === this.state.date), this.state.dates.dates)
        })
      }
    })
  }

  handleChange = (event) => this.setSelectionField(event.target.name, event.target.value);

  render() {
    const { pairs, pair, dates, date } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <FormControl className={classes.pairControl}>
          <InputLabel htmlFor="pair-selector">Selected Pair</InputLabel>
          <Select value={pair} onChange={this.handleChange} inputProps={{name: 'pair', id: 'pair-selector'}}>
            {pairs.pairs.map((pair, i) => <MenuItem key={i} value={pair.name}>{pair.name}</MenuItem>)}
          </Select>
        </FormControl>
        &nbsp;
        &nbsp;
        <FormControl className={classes.dateControl}>
          <InputLabel htmlFor="date-selector">Expiration Date</InputLabel>
          <Select value={date} onChange={this.handleChange} inputProps={{name: 'date', id: 'date-selector'}}>
            {dates.dates.map((date, i) => <MenuItem key={i} value={date.valueOf()}>{date.toISODate()}</MenuItem>)}
          </Select>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(PairDatePicker);


// WEBPACK FOOTER //
// ./src/PairDatePicker.js